import {Issue} from "../domain/entities/issue.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class DeleteIssueCommand extends AbstractCommand<Issue> {

    public name: CommandName = CommandName.DELETE_ISSUE;

    public tags = ['entity', 'delete', 'issue'];

    constructor(payload: Issue) {
        super('issue', payload.uid, payload);
    }

}